export const ENVIRONMENT_MASTER = 'Master'
export const ENVIRONMENT_STAGING = 'Staging'
export const ENVIRONMENT_DEVELOPMENT = 'Development'
export const ENVIRONMENT_LOCALHOST = 'localhost'
export const LOCAL_ENV_DEVELOPMENT = 'development'

export const HOSTS = {
  LOCAL: 'localhost:8000',
  PREVIEW_PROD: 'production-uipath-preview.azurewebsites.net',
  PREVIEW_STAGING: 'staging-uipath-preview.azurewebsites.net',
  PREVIEW_DEV: 'development-uipath-preview.azurewebsites.net',
  PROD: 'uipath.com',
  STAGING: 'staging.uipath-dev.com',
  DEV: 'uipath-dev.com',
  CN_PROD: 'uat.uipath.com.cn',
  CN_STAGING: 'qa.uipath.com.cn',
  CN_DEV: 'cn.uipath-dev.com',
}

export const URLS = {
  PROD: 'https://www.uipath.com',
  CN_PROD: 'https://www.uipath.com.cn',
}
